// src/NotificationListener.tsx

import { useAppDispatch } from "../hooks";
import useNotificationSocket from "../hooks/useNotificaitonSocket";
import { ListResponse } from "../interfaces";
import { ChatBatch } from "../interfaces/chat.interface";
import { chatApi } from "../redux/chat/chat.api";

export default function NotificationListener() {
  const dispatch = useAppDispatch();

  useNotificationSocket({ muteSound: false, showToast: true, showBrowserNotification: true }, (msg) => {
    dispatch(
      chatApi.util.updateQueryData("getChatBatches", {}, (draft: ListResponse<ChatBatch>) => {
        const batch = draft.entries.find((b) => b.id === msg.chat?.batch_id);
        if (batch) {
          if (batch.chat) {
            batch.chat.unread_count = batch.chat.unread_count + 1;
            batch.chat.last_message = msg;
          }
        }
      })
    );
  });
  return null;
}
